import {SeoContent} from '@app/marketplace/seo-content/seo-content';
import {ActivatedRoute, Router} from '@angular/router';
import {Meta, Title} from '@angular/platform-browser';
import {Observable, Subscription} from 'rxjs';
import {Configuration} from '@app/marketplace/products/_models/product.interface';
import {Store} from '@ngrx/store';
import {ConfigurationPagedSelectorModel, PaginationSelectorModel} from '@app/marketplace/shared/_models/pagination-selector.model';
import {isPlatformBrowser} from '@angular/common';

export class PaginatorComponent<T> extends SeoContent {

  public isLoading$: Observable<boolean>;
  public items$: Observable<T[]>;
  public pageSize$: Observable<number>;
  public pageNo$: Observable<number>;
  public totalPages$: Observable<number>;
  public count$: Observable<number>;
  public totalData$: Observable<number>;
  public configuration$: Observable<Configuration>;
  subscriptions: Subscription[] = [];

  paginatorStore: Store<any>;

  constructor(route: ActivatedRoute | null,
              metaService: Meta | null,
              titleService: Title | null,
              router: Router | null,
              store: Store<any>,
              platformId: any,
              selector: PaginationSelectorModel<T>) {
    super(route, metaService, titleService, router);
    if (isPlatformBrowser(platformId)) {
      this.paginatorStore = store;
      this.isLoading$ = this.paginatorStore.select(selector.selectLoading);
      this.items$ = this.paginatorStore.select(selector.selectItems);
      this.pageSize$ = this.paginatorStore.select(selector.selectPageSize);
      this.pageNo$ = this.paginatorStore.select(selector.selectPageNo);
      this.totalPages$ = this.paginatorStore.select(selector.selectTotalPage);
      this.totalData$ = this.paginatorStore.select(selector.selectTotalData);
      this.count$ = this.paginatorStore.select(selector.selectCount);
      this.subscriptions.push(this.isLoading$.subscribe(), this.items$.subscribe(), this.pageSize$.subscribe(), this.pageNo$.subscribe(), this.totalPages$.subscribe(), this.totalData$.subscribe(), this.count$.subscribe());
    }
  }

  OnDestroy() {
    this.subscriptions.forEach(x => x.unsubscribe());
  }
}

export class ConfigurationPagedComponent<T> extends PaginatorComponent<T> {
  public configuration$: Observable<Configuration>;

  constructor(route: ActivatedRoute | null,
              metaService: Meta | null,
              titleService: Title | null,
              router: Router | null,
              store: Store<any>,
              platformId: any,
              selector: ConfigurationPagedSelectorModel<T>) {
    super(route, metaService, titleService, router, store, platformId, selector);
    if (isPlatformBrowser(platformId)) {
      this.configuration$ = this.paginatorStore.select(selector.selectConfiguration);
      this.subscriptions.push(this.configuration$.subscribe());
    }
  }

  OnDestroy() {
    super.OnDestroy();
  }
}
